import Head from 'next/head'
import getConfig from 'next/config'
import { useRouter } from 'next/router'
import { insertDynamicText } from '../../controllers/helpers'
import { orgSchema } from '../../constants'

const { nonce } = getConfig().publicRuntimeConfig

export const Meta = ({
  metaDescription,
  metaTitle,
  schema,
  host,
  displayLocation = '',
  nicheOrEventName = ''
}) => {
  const { query } = useRouter()

  const pagination = query?.page ? `?page=${query.page}` : ''
  const pageNumber = query?.page ? ` - page ${query.page}` : ''

  metaTitle = insertDynamicText(metaTitle, displayLocation, nicheOrEventName)
  metaDescription = insertDynamicText(metaDescription, displayLocation, nicheOrEventName)

  const Schema = ({ schema }) => {
    if (!schema) return null
    return (
      <Head>
        {schema?.venues && (
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema.venues) }}
          />
        )}
        {schema?.faqs && (
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema.faqs) }}
          />
        )}
        {schema?.breadcrumbs && (
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema.breadcrumbs) }}
          />
        )}
        {schema?.article && (
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema.article) }}
          />
        )}
        {schema?.author && (
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema.author) }}
          />
        )}
        <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      </Head>
    )
  }

  return (
    <>
      <Head>
        <title>{`${metaTitle}${pageNumber}`}</title>
        <meta property='og:title' content={metaTitle} key='title' />
        {!!host && <link rel='canonical' href={`https://${host}/${query.slug.join('/')}`} />}
        <meta name='description' content={`${metaDescription}${pageNumber}`} />
      </Head>
      <Schema schema={schema} />
    </>
  )
}
